import { base64Decode } from '@lcsc-design/utils/base64';

import decryptSm2 from './decrypt-sm2';
import setKeyPair from './set-key-pair';

import Utils from '@lcsc-ui/utils/Utils';

/**
 * @desc: lcsc统一解密(该加密方式会在localStorage取对应的私钥进行解密)
 * @param {string} str
 * @param {string} decryptPrivateHexKey 可选
 * @return {*} 解码结果
 * @author: 龙健
 */
export default function lcscDecrypt(str, decryptPrivateHexKey) {
  // 校验是否是加密串
  const reg = /^({secret.*})(.+)/;

  // 非加密串 直接返回
  if (!reg.test(str)) {
    return str;
  }

  // 判断有无传私钥 没有则取localStorage中的私钥
  if (!decryptPrivateHexKey) {
    const keyPair = Utils.getLocal('keyPair');
    decryptPrivateHexKey = keyPair.decryptPrivateHexKey;
  }

  if (!decryptPrivateHexKey) {
    console.error('缺少私钥');
    setKeyPair();
    throw new Error('操作失败,请重试');
  }

  // 截取加密串 去除多余部分
  const encryptStr = str.replace(reg, '$2');

  // 解密步骤 1.sm2解密 -> 2.base64解码
  const sourceText = decryptSm2(encryptStr, decryptPrivateHexKey);

  // 当返回的结果为空 -> 解密失败(重新获取密钥)
  if (sourceText === '') {
    setKeyPair();
    throw new Error('解密失败,请重试');
  }
  return base64Decode(sourceText);
}
